export const system = {
  accessTokenKey: 'access_token',
  refreshTokenKey: 'refresh_token',
  curUserIdKey: 'cur_user_id',
}
